import React from 'react';
import LogMissionEntry from './LogMissionEntry';

const LogSessionCard = ({ log }) => {
    return (
        <div className="bg-white border border-gray-100 rounded-3xl p-6 shadow-sm mb-6 last:mb-0">
            {/* User Header Info */}
            <div className="mb-4">
                <h2 className="text-xl font-bold text-gray-900 leading-tight">{log.name}</h2>
                <div className="mt-1 space-y-0.5">
                    <p className="text-sm text-gray-500 font-medium tracking-tight">Username: {log.username}</p>
                    <p className="text-sm text-gray-500 font-medium tracking-tight">Employee Id: {log.employeeId}</p>
                    <p className="text-sm text-gray-500 font-medium tracking-tight">DSID: {log.dsid}</p>
                </div>
            </div>

            {/* Time Info */}
            <div className="mb-6 space-y-0.5">
                <p className="text-sm text-gray-500 font-medium tracking-tight">Started at: {log.startedAt}</p>
                <p className="text-sm text-gray-500 font-medium tracking-tight">Stopped at: {log.stoppedAt}</p>
            </div>

            {/* Mission Entries Wrapper */}
            <div className="border border-gray-100 rounded-2xl p-4 bg-gray-50/30">
                {(log.missions && Array.isArray(log.missions) ? log.missions : [log]).map((mission, idx) => (
                    <LogMissionEntry key={idx} mission={mission} />
                ))}
            </div>
        </div>
    );
};

export default LogSessionCard;
